/**
 * Bossa Nova Home Scales Section - JavaScript
 * Transitions only colors (CSS variables) and center image
 */

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('[data-bn-scales-slider]');
  if (!slider) return;

  const images = Array.from(slider.querySelectorAll('.bn-scales__image'));
  const dots = Array.from(slider.querySelectorAll('[data-bn-scales-dot]'));

  // Define color variables for each slide
  const colorThemes = [
    { // 0: Reserva (Verde)
      '--panel-bg': '#9BA97D',
      '--panel-hover': '#9BA97D',
      '--text': '#2f372b',
      '--muted': '#465042',
      '--line': 'rgba(47, 55, 43, 0.28)',
      '--accent': '#758457'
    },
    { // 1: Solar (Amarelo)
      '--panel-bg': '#e5a771',
      '--panel-hover': '#dfa066',
      '--text': '#3f3a2f',
      '--muted': '#5b5248',
      '--line': 'rgba(63, 58, 47, 0.24)',
      '--accent': '#ab601f'
    },
    { // 2: Poesia (Vermelho)
      '--panel-bg': '#ddbfa5',
      '--panel-hover': '#ddbfa5',
      '--text': '#3f3a2f',
      '--muted': '#5b5248',
      '--line': 'rgba(63, 58, 47, 0.24)',
      '--accent': '#9c445a'
    },
    { // 3: Movimento (Azul)
      '--panel-bg': '#abd0db',
      '--panel-hover': '#abd0db',
      '--text': '#1a3a44',
      '--muted': '#2d4a54',
      '--line': 'rgba(26, 58, 68, 0.24)',
      '--accent': '#2E8AA4'
    }
  ];

  let currentIndex = 0;
  let autoplayInterval = null;
  let isAnimating = false;

  /**
   * Apply color theme to slider container
   */
  function applyTheme(index) {
    const theme = colorThemes[index];
    for (const [key, value] of Object.entries(theme)) {
      slider.style.setProperty(key, value);
    }
  }

  /**
   * Navigate to a specific slide
   */
  function goToSlide(index) {
    if (isAnimating) return;
    const nextIndex = ((index % images.length) + images.length) % images.length;
    if (nextIndex === currentIndex) return;

    isAnimating = true;

    // Change center image
    images[currentIndex].classList.remove('is-active');
    images[nextIndex].classList.add('is-active');

    // Change dots
    dots[currentIndex]?.classList.remove('is-active');
    dots[nextIndex]?.classList.add('is-active');

    // Update aria-current
    dots.forEach((dot, idx) => {
      if (idx === nextIndex) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    // Apply new colors
    applyTheme(nextIndex);

    currentIndex = nextIndex;

    setTimeout(() => {
      isAnimating = false;
    }, 600); // Matches CSS transition time
  }

  function nextSlide() {
    goToSlide(currentIndex + 1);
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, 5000);
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Setup event listeners
  dots.forEach((dot, index) => {
    dot.addEventListener('click', function () {
      goToSlide(index);
      startAutoplay();
    });

    dot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        goToSlide(index);
        startAutoplay();
      }
    });
  });

  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);
  slider.addEventListener('focusin', stopAutoplay);
  slider.addEventListener('focusout', startAutoplay);

  // Initialize
  applyTheme(0);
  startAutoplay();

  window.addEventListener('beforeunload', stopAutoplay);
});